import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { getApiFieldErrors } from "./api-error";

export function applyFieldErrorsToForm<T extends FieldValues>(
  error: unknown,
  form: UseFormReturn<T>,
  knownFields?: readonly Path<T>[],
): boolean {
  const fieldErrors = getApiFieldErrors(error);
  if (!fieldErrors) return false;

  const known = new Set<string>(
    knownFields ?? (Object.keys(form.getValues()) as string[]),
  );

  let matched = 0;
  Object.entries(fieldErrors).forEach(([field, message]) => {
    if (!known.has(field)) return;
    form.setError(field as Path<T>, { message });
    matched++;
  });

  return matched > 0;
}
